module.exports = __webpack_public_path__ + "img/197.blockage_toilet.64942e99.svg";